define([
    "views/common/vn_modal_view",
    "jquery",
    "underscore",
    "marionette",
    "models/quote_model",
    "templates/trading/main_quote_list_item.html",
    "forms/register/land_prime_form",
    "behaviors/form_errors_behavior",
    "behaviors/recaptcha_v3_behavior",
    "moment",
    "bootstrap.datepicker",
    "backbone.syphon",
    "holdon",
], function (
    VnModalView,
    $,
    _,
    Marionette,
    Quote,
    mainQuoteListItem,
    LandPrimeForm,
    FormErrorsBehavior,
    ReCaptchaV3Behavior,
    moment,
) {
    return Marionette.View.extend({
        el: "#content_layout",

        behaviors: {
            formErrors: {
                behaviorClass: FormErrorsBehavior,
            },
            recaptcha: {
                behaviorClass: ReCaptchaV3Behavior,
                action: '/register'
            }
        },

        ui: {
            quickRegistrationForm: "#quick-registration-form",
            submitQuickRegistration: "#submit-quick-registration",

            // EMAIL
            email: "#email",
            sendEmailValidation: "#send_email_validation",
            sendEmailValidationFallback: "#send_email_validation_fallback",
            checkEmailValidation: "#check_email_validation",
            emailValidationId: ".email_validation_id",
            emailValidationForm: "#email_validation_form",
            emailSendForm: "#email_send_form",
            emailValidationCode: "#email_validation",
            emailValidationSuccessIcon: "#email_validation_success",
            emailValidationPassed: ".email_validation_passed",
            resendVerificationEmail: "#resend-email-verification",

            // common validation purpose
            validationType: ".validation_type",
            validationId: ".validation_id",
            validationPassed: ".validation_passed",

            birthDatePicker: "#birth",

            // EMAIL
            emailValidationCodeFormGroup: "#form-group-email-validation-code",
            emailValidationDesc: "#email_validation_desc",

            // PASSWORD
            showPasswordBtn: "#show_password_btn",
            showConfirmPasswordBtn: "#show_confirm_password_btn",
            passwordInput: "#password",
            confirmPasswordInput: "#confirm_password",
        },

        events: {
            "click .member_type": function (e) {
                if (e) e.preventDefault();

                var type = $(e.currentTarget).data("type");
                if (type) {
                    this.$el.find(".quote_type").removeClass("active");
                    this.$el.find(".ct_nav1 li:first-child a").addClass("active");
                    this.memberType = type;
                    this.getQuotes();
                    this.displayAccountTypeSpread(type);
                }
            },
            "click @ui.submitQuickRegistration": "submitQuickRegistration",
            "click @ui.sendEmailValidation": "sendEmailValidation",
            "click @ui.checkEmailValidation": "checkEmailValidation",
            "click @ui.resendVerificationEmail": "resendEmailValidation",
            "click @ui.showPasswordBtn": "showPasswordBtn",
            "click @ui.showConfirmPasswordBtn": "showConfirmPasswordBtn",
            "keyup @ui.passwordInput": "passwordValidation",
            "keyup @ui.confirmPasswordInput": "isSamePasswordValidation",
        },

        initialize: function () {
            // this.vnPromoModal = new VnModalView();

            this.bindUIElements();
            // recaptcha
            this.triggerMethod("init:recaptcha");

            this.doNotProvokeSubmitByEnterKey();

            this.memberType = $(".quote_type.active .member_type").data("type");

            this.getQuotes();

            // Cache the selector to avoid reading the dom every 1.5s.
            this.$trSelector = $(".quotes_row li");

            this.ui.validationType.val("email");
            this.ui.sendEmailValidation.show();

            if (window.lang === "zh_CN") {
                $("#china_service").modal("show");
            }

            this.ui.birthDatePicker
                .datetimepicker({
                    viewMode: "years",
                    format: "YYYY-MM-DD",
                    // We need to be 20years old to register to let's have the max date be 20years from now
                    maxDate: moment().subtract(18, "y"),
                })
                .val("");
        },

        showPasswordBtn: function () {
            let inputElem = document.getElementById("password");
            if (inputElem.type === "text") {
                document.getElementById("show_password_btn_img").src =
                    "/assets/common/common/img/eye_icon.svg";
                inputElem.type = "password";
            } else {
                document.getElementById("show_password_btn_img").src =
                    "/assets/common/common/img/hide_eye.svg";
                inputElem.type = "text";
            }
        },

        showConfirmPasswordBtn: function () {
            let inputElem = document.getElementById("confirm_password");
            if (inputElem.type === "text") {
                inputElem.type = "password";
                document.getElementById("show_confirm_password_btn_img").src =
                    "/assets/common/common/img/eye_icon.svg";
            } else {
                inputElem.type = "text";
                document.getElementById("show_confirm_password_btn_img").src =
                    "/assets/common/common/img/hide_eye.svg";
            }
        },

        // 여기에서 password validation
        passwordValidation: function (e) {
            let password = e.target.value;

            // 글자수 8자 이상, 15자 이하
            let lengthRule = /^.{8,15}$/;
            if (lengthRule.test(password)) {
                document.getElementsByClassName("length")[0].style.display = "none";
            } else {
                document.getElementsByClassName("length")[0].style.display = "flex";
            }

            // 숫자 하나 이상 포함
            let digitRule = /\d/;
            if (digitRule.test(password)) {
                document.getElementsByClassName("number")[0].style.display = "none";
            } else {
                document.getElementsByClassName("number")[0].style.display = "flex";
            }

            // 특수문자 하나 이상 포함
            let specialCharRule = /[!@#$%^*+=-]+/;
            if (specialCharRule.test(password)) {
                document.getElementsByClassName("special-character")[0].style.display =
                    "none";
            } else {
                document.getElementsByClassName("special-character")[0].style.display =
                    "flex";
            }

            // 염문 대문자/소문자 포함
            let uppercaseRule = /(?=.*[a-z])(?=.*[A-Z])/;
            if (uppercaseRule.test(password)) {
                document.getElementsByClassName("uppercase")[0].style.display = "none";
            } else {
                document.getElementsByClassName("uppercase")[0].style.display = "flex";
            }
        },

        isSamePasswordValidation: function (e) {
            let passwordForConfirm = e.target.value;
            if (
                document.getElementById("password").value === passwordForConfirm
            ) {
                document.getElementsByClassName("passwordConfirmMsg")[0].style.display =
                    "none";
            } else {
                document.getElementsByClassName("passwordConfirmMsg")[0].style.display =
                    "flex";
            }
        },

        doNotProvokeSubmitByEnterKey: function () {
            window.onkeydown = function (event) {
                if (event.keyCode === 13) {
                    event.preventDefault();
                    return false;
                }
            };
        },

        displayAccountTypeSpread: function (type) {
            $(".account_type_spread").hide();
            $(`#${type}_account_type_spread`).show();
        },

        getQuotes: function () {
            var that = this;

            var quote = new Quote();
            // Return the fetch promise
            return quote.fetch({
                data: {
                    member_type: this.memberType,
                    security: "forex",
                    need_to_sort: false,
                    is_main_symbol: true,
                    page: "main",
                    t: $.now(),
                },
                success: function (model, response, option) {
                    // $('#quotes_list').html('');
                    let i = 0;
                    _.each(model.get("quotes"), function (element, key, list) {
                        let fractionDigits = 4;
                        if (element.symbol === "USD/JPY") fractionDigits = 2;
                        else if (element.symbol === "XAU/USD") {
                            // Sometimes, XAU/USD bid or ask is 7 digits number
                            // example) 1984000, so it takes only first 4 characters.
                            if (element.ask.length >= 7) {
                                element.ask = element.ask.substring(0, 4);
                            }
                            if (element.bid.length >= 7) {
                                element.bid = element.bid.substring(0, 4);
                            }
                            fractionDigits = 1;
                        }

                        element.bid = Number(element.bid).toFixed(fractionDigits);
                        element.ask = Number(element.ask).toFixed(fractionDigits);

                        $(`#symbol${i}`).text(element.symbol);
                        $(`#bid${i}`).text(element.bid);
                        $(`#ask${i}`).text(element.ask);
                        $(`#spread${i}`).text(element.spread);

                        i++;
                    });
                },
                fail: function (model, response, option) {
                },
            });
        },

        submitQuickRegistration: function (e) {
            if (e) e.preventDefault();

            this.triggerMethod('hide:errors');
            HoldOn.open({
                theme: "sk-fading-circle"
            });

            var formData = Backbone.Syphon.serialize(this);
            this.landPrimeForm = new LandPrimeForm();
            this.landPrimeForm.set(formData);

            var errors = this.landPrimeForm.validate();

            var that = this;

            if (_.size(errors) < 1) {
                this.triggerMethod('get:token', function (err, token) {
                    that.triggerMethod('set:token', token, that.ui.quickRegistrationForm);
                    formData = Backbone.Syphon.serialize(that);
                    that.landPrimeForm.set(formData);

                    that.landPrimeForm.validateWithServer({
                        type: 'POST',
                        success: function (model, res) {
                            that.ui.quickRegistrationForm.submit();
                        },
                        error: function (model, error) {
                            that.triggerMethod('show:errors', error.responseJSON);
                            HoldOn.close();
                        }
                    });
                });
            } else {
                HoldOn.close();
                this.triggerMethod('show:errors', errors);
            }
        },

        // EMAIL VALIDATION : Resend verification code SMS
        resendEmailValidation: function (e) {
            if (e) e.preventDefault();
            this.sendEmailValidation(e);
        },

        // EMAIL VALIDATION : SEND-CODE TO THE INPUT EMAIL ADDRESS
        sendEmailValidation: function (e) {
            if (e) e.preventDefault();

            var that = this;
            that.triggerMethod("hide:errors");


            HoldOn.open({
                theme: "sk-fading-circle",
            });

            $.ajax('/rest_register/send_email_validation_code', {
                method: "POST",
                data: {
                    email_address: this.ui.email.val(),
                },
                success: function (data) {
                    that.triggerMethod("hide:errors");
                    that.ui.validationId.val(data.secureVerificationCd);

                    that.ui.resendVerificationEmail.show();
                    that.ui.sendEmailValidation.hide();

                    that.ui.emailValidationCodeFormGroup.css("display", "block");
                    that.ui.emailValidationDesc.css("display", "block");

                    HoldOn.close();
                },
                error: function (xhr, textStatus, errorThrown) {
                    var error = xhr.responseJSON;
                    that.triggerMethod('show:errors', {'email': error.error_message});
                    HoldOn.close();
                },
            });
        },

        // EMAIL VALIDATION AFTER CLICKING CODE VERIFICATION
        checkEmailValidation: function (e) {
            if (e) e.preventDefault();

            var that = this;
            that.triggerMethod("hide:errors");
            that.ui.emailValidationDesc.css("display", "none");

            HoldOn.open({
                theme: "sk-fading-circle",
            });

            $.ajax('/rest_register/verify_email_validation', {
                method: "POST",
                data: {
                    email_address: this.ui.email.val(),
                    request_id: this.ui.validationId.val(),
                    code: this.ui.emailValidationCode.val(),
                },
                success: function (data) {
                    that.triggerMethod("hide:errors");
                    that.ui.validationType.val("email");
                    that.ui.validationPassed.val("true");

                    that.ui.emailValidationSuccessIcon.show()

                    that.ui.emailValidationCodeFormGroup.css("display", "none");

                    that.ui.resendVerificationEmail.attr("disabled", true);
                    that.ui.resendVerificationEmail.css("color", "#AAB7F2");
                    that.ui.resendVerificationEmail.css("border", "1px solid #AAB7F2");

                    that.ui.email.css("color", "#AAB7F2");
                    that.ui.email.addClass("inactive");
                    that.ui.email.attr("readonly", true);

                    HoldOn.close();
                },
                error: function (xhr, textStatus, errorThrown) {
                    var error = xhr.responseJSON;
                    if (error.error_message) {
                        that.triggerMethod('show:errors', {'email_validation': error.error_message});
                    }
                    HoldOn.close();
                },
            });
        },
    });
});
